export default __webpack_public_path__ + "static/AdobeStock_smaller-c3ca0893728f825c2ff38b5ec7895f0c.jpeg";